import React from 'react';
import { formatDate } from '../utils/formatDate';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const formattedDate = formatDate(payload[0].payload.date);
    const total = payload[0].value;
    return (
      <div
        style={{
          backgroundColor: 'white',
          border: '1px solid lightgrey',
          borderRadius: '4px',
          padding: '0px 5px 2px 5px',
        }}
      >
        <span style={{ fontSize: '12px', color: '#000', fontWeight: 'bold'}}>
          {formattedDate} - {total}
        </span>
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
